import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DEVICE_TYPES } from '../interfaces/data-studio.interface';

@Injectable({
  providedIn: 'root'
})
export class DataStudioHelperService {

  public date$ = new Subject();
  public dataLive$ = new Subject();
  public typeSelection: string = DEVICE_TYPES.TURBINE;

  public getDateObservable$(): Observable<any> {
    return this.date$.asObservable();
  }

  public getDateObservableLiveData$(): Observable<any> {
    return this.dataLive$.asObservable();
  }

  public setDateObservable$(data: any) {
    this.date$.next(data);
  }

  public setDateObservableLiveData$(data: any) {
    this.dataLive$.next(data);
  }

  public naturalCompare(a, b) {
    return a.name.localeCompare(b.name, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }
}
